export enum ProductDisplaysEnum {
  PRODUCT_GROUP_DISPLAY_LIUNE_ART_DOOR = 'product_group_display_liune_art_door',
  PRODUCT_GROUP_DISPLAY_LIUNE_FAMILY = 'product_group_display_liune_family',
  PRODUCT_GROUP_DISPLAY_LIUNE_ELEMENT = 'product_group_display_liune_element',
  PRODUCT_GROUP_DISPLAY_LIUNE_SPECIAL_DOOR_FRAME = 'product_group_display_liune_special_door_frame',
  PRODUCT_GROUP_DISPLAY_LIUNE_SURFACE_DOOR = 'product_group_display_liune_surface_door',
  PRODUCT_GROUP_DISPLAY_LIUNE_PRODUCT_FAMILY_LIST = 'product_group_display_liune_product_family_list',
  PRODUCT_GROUP_DISPLAY_LIUNE_DOOR_FRAME = 'product_group_display_liune_door_frame',
  SINGLE_PRODUCT_DISPLAY = 'single_product_display',
}
